module.exports = __webpack_public_path__ + "img/dienteTratamiento.58780b5a.svg";